import en_US from 'antd/lib/locale/en_US';
import hr_HR from 'antd/lib/locale/hr_HR';

export const ANTDLOCALES = {
  hr: hr_HR,
  en: en_US,
} as any;
